import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgClose = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      fillRule="evenodd"
      d="M11.717 12.778a.75.75 0 0 0 1.061 0 .75.75 0 0 0 0-1.06L9.05 7.998l3.728-3.719a.75.75 0 0 0 0-1.06.75.75 0 0 0-1.061 0L7.989 6.94 4.28 3.24a.75.75 0 0 0-1.062 0 .75.75 0 0 0 0 1.06l3.708 3.7-3.708 3.7a.75.75 0 0 0 0 1.06.75.75 0 0 0 1.062 0l3.708-3.7z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgClose);
export default ForwardRef;
